import {
    getDisplayValue
} from '../format-display-value';

/**
 * Hourly data should have the following structure:
 * {
 *      DF: "string",
 *      DateTime: "string",
 *      Direction: "string",
 *      FBI: "string",
 *      FDR: "string",
 *      Humidity: "string",
 *      Speed: "string",
 *      Temperature: "string"
 * }
 * @param {*} hourlyData 
 * @param {*} detailsContainer 
 */
export function drawRHChart(hourlyData, detailsContainer, chartHeight) {
    // Create the temperature data array
    const temp = [['Datetime', 'RelativeHumidity']];

    hourlyData.forEach((item) => {
        temp.push([
            new Date(item['DateTime']), getDisplayValue(item['Humidity'], 'RH')
        ]);
    })

    const data = google.visualization.arrayToDataTable(temp);

    const options = {
        title: 'Relative Humidity (%)',
        legend: 'none',
        chartArea: {width: '85%'},  // Adjust chart area
        height: +chartHeight.slice(0, -2)
    };

    const chartContainer = $(`<div class="no-data ` + 
            `line-chart-container ` + 
            `chart-container-style" ` + 
            `id="rh-line-chart-id"` + 
            `style="height:${chartHeight};"></div>`);
    detailsContainer.append(chartContainer);

    const chart = new google.visualization.LineChart(document.getElementById('rh-line-chart-id'));
    chart.draw(data, options);
}